import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import React, { forwardRef, useRef, useEffect } from 'react';
import { themed } from '@indeed/ifl-css';
import { Chip } from './Chip.js';
import useResponsiveValue from '../../hooks/useResponsiveValue.js';
import { matchesDisplayName } from '../../utils/displayName.js';
import { jsx } from '@emotion/react';
import { Box } from '../Box/Box.js';
import 'focus-visible';
import '@emotion/is-prop-valid';
import '@indeed/ihl-use-id';
import '@indeed/ifl-icons';
import '../../utils/transition.js';
import '../../constants/index.js';
import '../Button/Button.js';
import '../../utils/styled.js';
import '../../utils/createResponsive.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../Spinner/Spinner.js';
import '../IconWrapper/IconWrapper.js';
import '../Label/Label.js';
import '../../utils/warnDeprecation.js';
import '../../utils/warn.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../Flex/Flex.js';
import '../../hooks/useBreakpointIndex.js';

const margins = {
  sm: -2,
  md: -2,
  lg: -2
};
const baseStyles = _ref => {
  let {
    size
  } = _ref;
  return {
    display: "flex",
    flexWrap: "wrap",
    listStyleType: "none",
    paddingBlockStart: 0,
    paddingBlockEnd: 0,
    paddingInlineStart: 0,
    paddingInlineEnd: 0,
    marginBlockEnd: 0,
    marginInlineEnd: 0,
    marginBlockStart: margins[size],
    marginInlineStart: -2
  };
};
const ChipList = /*#__PURE__*/themed("ul", process.env.NODE_ENV === "production" ? {
  styleProps: ["size"],
  shouldForwardProp: prop => prop !== "size",
  target: "ehgddzl0"
} : {
  styleProps: ["size"],
  shouldForwardProp: prop => prop !== "size",
  target: "ehgddzl0",
  label: "ChipList"
})(baseStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const ChipGroup = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    className,
    children,
    listProps,
    sx,
    tabIndex,
    onFocus,
    onBlur,
    id,
    ...chipProps
  } = _ref2;
  const {
    type = "single",
    size = "md"
  } = chipProps;
  const chipSize = useResponsiveValue(size);
  const listRef = useRef(null);
  useEffect(() => {
    if (type === "removable" && listRef.current !== null) {
      // Allow first chip to be focusable if no other chips have tabindex of 0
      const cells = listRef.current.querySelectorAll("[tabindex]");
      const tabbableCells = listRef.current.querySelectorAll('[tabindex="0"]');
      if (cells.length > 0 && tabbableCells.length === 0) {
        cells[0].setAttribute("tabindex", "0");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children]);
  const focusCell = dir => {
    if (listRef.current === null) {
      return;
    }
    const cells = listRef.current.querySelectorAll("[tabindex]");
    // Find currently focused cell
    let currentCellIndex = 0;
    for (let i = 0; i < cells.length; i++) {
      var _thisCell$attributes$;
      const thisCell = cells[i];
      if (thisCell && ((_thisCell$attributes$ = thisCell.attributes.getNamedItem("tabindex")) == null ? void 0 : _thisCell$attributes$.value) === "0") {
        currentCellIndex = i;
      }
    }
    const previousIndex = currentCellIndex;
    let nextIndex = previousIndex;
    switch (dir) {
      case "next":
        nextIndex = Math.min(cells.length - 1, previousIndex + 1);
        break;
      case "prev":
        nextIndex = Math.max(0, previousIndex - 1);
        break;
      case "first":
        nextIndex = 0;
        break;
      case "last":
        nextIndex = cells.length - 1;
        break;
      case "nextOrPrev":
        nextIndex = Math.min(cells.length - 1, previousIndex + 1);
        if (nextIndex === currentCellIndex) {
          nextIndex = Math.max(0, currentCellIndex - 1);
        }
        break;
    }
    if (nextIndex !== previousIndex && previousIndex < cells.length) {
      cells[previousIndex].setAttribute("tabindex", "-1");
    }
    cells[nextIndex].setAttribute("tabindex", "0");
    cells[nextIndex].focus();
  };
  const handleKeyDown = e => {
    let handled = true;
    switch (e.key) {
      case "ArrowDown":
      case "Down":
      case "ArrowRight":
      case "Right":
        focusCell("next");
        break;
      case "ArrowLeft":
      case "Left":
      case "ArrowUp":
      case "Up":
        focusCell("prev");
        break;
      case "Home":
        focusCell("first");
        break;
      case "End":
        focusCell("last");
        break;
      default:
        handled = false;
    }
    if (handled) {
      e.preventDefault();
    }
  };
  const chipListProps = type === "removable" ? {
    onKeyDown: handleKeyDown,
    ...listProps
  } : {
    ...listProps
  };
  return jsx(Box, {
    id: id,
    className: className,
    sx: sx,
    ref: ref,
    tabIndex: tabIndex,
    onFocus: onFocus,
    onBlur: onBlur
  }, jsx(ChipList, _extends({
    ref: listRef,
    size: chipSize
  }, chipListProps), React.Children.map(children, child => {
    if (! /*#__PURE__*/React.isValidElement(child) || !matchesDisplayName([Chip], child)) {
      return child;
    }
    const chip = /*#__PURE__*/React.cloneElement(child, {
      ...child.props,
      ...chipProps,
      onRemove: () => {
        focusCell("nextOrPrev");
        if (child.props.onRemove !== undefined) {
          child.props.onRemove();
        }
      }
    });
    return jsx(Box, {
      as: "li",
      sx: {
        flex: "0 1 auto"
      }
    }, chip);
  })));
});
ChipGroup.displayName = "ChipGroup";

export { ChipGroup };
